import type {Data} from 'schemaDefinition/types';
import type {BulkUpdateFailedItem} from 'services/bulkUpdates/types';

export function mapErrorsToData<TData extends Data = Data>(
  data: TData[],
  failedItems: BulkUpdateFailedItem[],
): TData[] {
  return data.map(i => {
    const error = failedItems.find(f => f.id === i.id);
    return {
      ...i,
      errorMessage: error?.error.key,
    };
  });
}
